import { Injectable } from '@angular/core';
import {
  MissingTranslationHandlerParams,
  MissingTranslationHandler,
} from '@ngx-translate/core';
import { NotTranslatedProvider } from 'src/app/services/not-translated/not-translated';

@Injectable({ providedIn: 'root' })
export class CustomMissingTranslationHandler
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams) {
    this.nts.notTranslated(params.key);
    return params.key;
  }

  constructor(private nts: NotTranslatedProvider) {}
}
